import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Facebook, Instagram, Twitter, Linkedin, ArrowUp } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_8c7177fb-7a38-4283-a68a-657840201e44/artifacts/mq62gpje_Vainavi-Educational-Institutions_Final_1.png";

export default function Footer() {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer data-testid="main-footer" className="bg-navy text-white">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <img
              src={LOGO_URL}
              alt="Vainavi Educational Institutions"
              className="h-24 w-auto brightness-0 invert"
              data-testid="footer-logo"
            />
            <p className="font-body text-sm text-slate-300 leading-relaxed">
              Shaping the future of global hospitality through excellence in education and hands-on training since our establishment in Hyderabad.
            </p>
            <div className="flex items-center gap-3 pt-2">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-crimson transition-colors duration-300">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-crimson transition-colors duration-300">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" data-testid="footer-twitter" className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-crimson transition-colors duration-300">
                <Twitter className="w-4 h-4" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-crimson transition-colors duration-300">
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-6 text-white">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { name: "Home", path: "/" },
                { name: "About Us", path: "/about" },
                { name: "Courses", path: "/courses" },
                { name: "Gallery", path: "/gallery" },
                { name: "Contact Us", path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s/g, '-')}`}
                    className="font-body text-sm text-slate-300 hover:text-crimson-light transition-colors duration-300"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-6 text-white">Programs</h4>
            <ul className="space-y-3">
              {[
                "B.H.M & Catering Technology",
                "B.Sc Hotel Management",
                "Diploma in Culinary Arts",
                "Intl. Diploma in Hotel Mgmt",
                "Diploma in Bartending",
                "Certificate in Mixology",
                "Integrated Program (5 Yr)",
              ].map((prog) => (
                <li key={prog}>
                  <Link
                    to="/courses"
                    className="font-body text-sm text-slate-300 hover:text-crimson-light transition-colors duration-300"
                  >
                    {prog}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-6 text-white">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-crimson-light flex-shrink-0 mt-0.5" />
                <span className="font-body text-sm text-slate-300">
                  M.S.P-6, 11-5-150/C,<br />Moosapet Rd, Bhavani Nagar,<br />Moosapet, Hyderabad,<br />Telangana 500018
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-crimson-light flex-shrink-0" />
                <a href="tel:+919963756669" className="font-body text-sm text-slate-300 hover:text-white transition-colors">
                  +91 99637 56669
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-crimson-light flex-shrink-0" />
                <a href="mailto:Vainavicollege@gmail.com" className="font-body text-sm text-slate-300 hover:text-white transition-colors">
                  Vainavicollege@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-slate-400">
            &copy; {new Date().getFullYear()} Vainavi Educational Institutions. All rights reserved.
          </p>
          <button
            onClick={scrollToTop}
            data-testid="scroll-to-top-btn"
            className="flex items-center gap-2 text-xs text-slate-400 hover:text-white transition-colors font-body uppercase tracking-wider"
          >
            Back to Top <ArrowUp className="w-3 h-3" />
          </button>
        </div>
      </div>
    </footer>
  );
}
